<template>
  <div>
    <div>
      <span v-if="showSave"></span>
      <span v-else-if="showUpdate">更新留言</span>
    </div>
    <div v-if="showUpdate">
      {{ replyUserName }}
    </div>
    <div style="padding-top: 10px;">
      <el-input
        type="textarea"
        :rows="6"
        placeholder="在这里输入您回复的内容"
        v-model="content"
      >
      </el-input>
    </div>
    <div v-if="showUpdate">
      创建时间: {{ new Date(replyAddDate).toLocaleString() }}
    </div>
    <div style="text-align: right; padding-top: 5px;">
      <span>
        <el-button
          title="返回"
          class="el-icon-back"
          circle
          @click="goBackFun"
        ></el-button>
      </span>
      <span v-if="showSave" style="margin-left: 20px;">
        <el-button
          title="发表您的回复"
          size="small"
          type="primary"
          @click="addOneNewFeedback"
          >回复</el-button
        >
      </span>
      <span v-else-if="showUpdate">
        <el-button size="small" type="primary" @click="updateOneFeedback"
          >更新</el-button
        >
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    appendPostId: Number,
    componentFunction: String,
    replyId: Number,
    replyContent: String,
    replyUserName: String,
    replyAddDate: Number
  },
  mounted () {
    if (this.componentFunction === 'save') {
      this.showSave = true
    } else if (this.componentFunction === 'update') {
      this.showUpdate = true
    }
  },
  data () {
    return {
      showSave: false,
      showUpdate: false,
      content: ''
    }
  },
  methods: {
    // 添加留言
    addOneNewFeedback: async function () {
      const api = '/md/front/bbs/feedback/postManage/sub/reply/addMainSub'
      let params = {
        postId: this.appendPostId,
        content: this.content
      }
      params = this.$qs.stringify(params)
      const res = await this.axios.post(api, params)
      if (res.status === 200) {
        this.$emit('flushNowPostListEvent')
        this.$emit('goBackEvent')
      }
    },
    // 更新留言
    updateOneFeedback: async function () {
      // 这里后台接口没有实现
      this.$emit('flushNowPostListEvent')
    },
    // 返回主帖列表
    goBackFun () {
      this.$emit('goBackEvent')
    }
  }
}
</script>

<style scoped></style>
